import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import cc1 from '../../img/MansoryMesh/cc1.png';
import cc2 from '../../img/MansoryMesh/cc2.png';
import cc3 from '../../img/MansoryMesh/cc3.png';
import cc4 from '../../img/MansoryMesh/cc4.png';
import cc5 from '../../img/MansoryMesh/cc5.png';
import cc6 from '../../img/MansoryMesh/cc6.png';

function MeshSizesAvailable () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("mansorymesh.add.1")}</Trans>
                    </p>
                </div>
                <div className='flex flex-wrap gap-[20px] mt-[35px] xl:mt-[65px]'>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc1} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.2")}</p>
                    </div>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc2} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.3")}</p>
                    </div>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc3} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.4")}</p>
                    </div>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc4} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.5")}</p>
                    </div>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc5} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.6")}</p>
                    </div>
                    <div className='w-[380px] h-[138px] flex-grow bg-[#272727] flex items-center px-[30px] gap-[15px]'>
                        <img src={cc6} alt="" className='w-[60px] xl:w-[97px] flex-shrink-0'/>
                        <p className='open-sans font-[600] text-[#F26522] text-[14px] xl:text-[16px]'>{t("mansorymesh.add.7")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MeshSizesAvailable;